import React from "react";
import { RouterProvider } from "react-router-dom";
import Loading from "@/components/Loading";
import { useAuth } from "../providers/AuthContext";
import { router } from "@/router/routerHelper";

const ClientRouter: React.FC = () => {
  const { isAuth } = useAuth();
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <React.Suspense fallback={<Loading />}>
        <RouterProvider router={router(isAuth)} fallbackElement={<Loading />} />
      </React.Suspense>
    </div>
  );
};

export default ClientRouter;
